import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as act from "../../../store/actions/anonAutoForm";
import {
  setPolicyNumber,
  sendAutoForm,
} from "../../../store/actions/anonymousForms";
import { formatSummaryDateTime } from "../../../utilities/formatUtilities";
import PageWrapper from "../../shared/wizard/PageWrapper";
import SummarySection from "../components/SummarySection";
import SummaryText from "../components/SummaryText";
import SummaryEditModal from "../components/SummaryEditModal";
import DateTimeEdit from "../edit-screens/shared-edit-screens/DateTimeEdit";
import YourInfoEdit from "../edit-screens/shared-edit-screens/YourInfoEdit";
import PolicyNumberEdit from "../edit-screens/shared-edit-screens/PolicyNumberEdit";
import LocationEdit from "../edit-screens/shared-edit-screens/LocationEdit";
import IncidentDetailsEdit from "../edit-screens/shared-edit-screens/IncidentDetailsEdit";
import DriverEdit from "../edit-screens/auto-edit-screens/DriverEdit";
import VehicleEdit from "../edit-screens/auto-edit-screens/VehicleEdit";
import PassengersEdit from "../edit-screens/auto-edit-screens/PassengersEdit";
import OtherPassengersEdit from "../edit-screens/auto-edit-screens/OtherPassengersEdit";
import InjuredPedestriansEdit from "../edit-screens/auto-edit-screens/InjuredPedestriansEdit";
import OtherVehicleEdit from "../edit-screens/auto-edit-screens/OtherVehicleEdit";
import PropertyEdit from "../edit-screens/auto-edit-screens/PropertyEdit";
import PoliceContactedEdit from "../edit-screens/auto-edit-screens/PoliceContactedEdit";
import WitnessesEdit from "../edit-screens/shared-edit-screens/WitnessesEdit";
import DocumentsEdit from "../edit-screens/shared-edit-screens/DocumentsEdit";
import SubmitConfirmAlert from "../components/SubmitConfirmAlert";
import Styles from "../styles/AnonSummaryStyles.module.css";
import { BehalfOfOptions, userTypes, vehicleOwnerOptions } from "../../../constants/options";
import { Canada, unknownName } from "../../../constants/data";
import {
  concatenateName,
  copyNestedObj,
  countryToCode,
  nameIsBlank,
  stateNameToCode,
  textToBoolean,
  booleanToText
} from "../../../utilities/dataUtilities";
import { fieldsToStrings, mapPersonArray, mapPassengerArray } from "../../../utilities/forms/formSubmissionUtilities";

function AutoClaimSummary({
  handleDocuments,
  config,
  fields,
  utilities,
  validatePage,
  witnesses,
  pedestrians,
  passengers,
  otherPassengers,
  setWitnesses,
  setPedestrians,
  setPassengers,
  setOtherPassengers,
  setFields
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  let documents = useSelector((state) => state.anonAutoForm.documents);
  let policyNumber = useSelector((state) => state.anonymousForms.policyNumber);
  let lossCauses = useSelector((state) => state.forms.lossCauses).filter(
    (item) => item.Auto
  );
  let typeOfClaim = useSelector((state) => state.anonymousForms.typeOfClaim);
  const witnessDisplay = [];
  witnesses
    .filter((witness) => !nameIsBlank(witness))
    .forEach((witness, index) => {
      witnessDisplay.push([
        `Name ${index + 1} `,
        `${concatenateName(witness)}`,
      ]);
      witnessDisplay.push([`Phone ${index + 1} `, witness.witnessPhone.value]);
    });
  //placeholder for unentered data
  const blankMessage = "- - -";

  const [displayAlert, setDisplayAlert] = useState(false);

  const [displayEdit, setDisplayEdit] = useState(false);

  const [originalValues, setOriginalValues] = useState(copyNestedObj(fields));

  useEffect(() => {
    if (displayEdit === false) {
      setOriginalValues(copyNestedObj(fields));
    }
  }, [displayEdit])

  const updateClicked = () => {
    if (validatePage(editPage, true)) {
      setDisplayEdit(false);
    }
  };

  const cancelClicked = () => {
    setFields(originalValues);
    setDisplayEdit(false);
  };

  const editScreens = [
    <DateTimeEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <PolicyNumberEdit
      policyNum={policyNumber}
      setPolicyNum={setPolicyNumber}
      setIsVisible={setDisplayEdit}
    />,
    <YourInfoEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <LocationEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <DriverEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <IncidentDetailsEdit
      lossCauses={lossCauses}
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <VehicleEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <WitnessesEdit
      setIsVisible={setDisplayEdit}
      isVisible={displayEdit}
      witnesses={witnesses}
      setWitnesses={setWitnesses}
      fields={fields}
      utilities={utilities}
      validatePage={validatePage}
      cancel={cancelClicked}
    />,
    <PassengersEdit
      setIsVisible={setDisplayEdit}
      isVisible={displayEdit}
      passengers={passengers}
      setPassengers={setPassengers}
      fields={fields}
      utilities={utilities}
      validatePage={validatePage}
      cancel={cancelClicked}
    />,
    <OtherPassengersEdit
      setIsVisible={setDisplayEdit}
      isVisible={displayEdit}
      passengers={otherPassengers}
      setPassengers={setOtherPassengers}
      fields={fields}
      utilities={utilities}
      validatePage={validatePage}
      cancel={cancelClicked}
    />,
    <InjuredPedestriansEdit
      setIsVisible={setDisplayEdit}
      isVisible={displayEdit}
      pedestrians={pedestrians}
      setPedestrians={setPedestrians}
      fields={fields}
      utilities={utilities}
      validatePage={validatePage}
      cancel={cancelClicked}
    />,
    <OtherVehicleEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <PropertyEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <PoliceContactedEdit
      fields={fields}
      utilities={utilities}
      updateClicked={updateClicked}
      cancelClicked={cancelClicked}
    />,
    <DocumentsEdit
      documents={documents}
      setDocuments={act.setAutoDocuments}
      config={config}
      handleDocuments={handleDocuments}
      setIsVisible={setDisplayEdit}
    />,
  ];
  const [editPage, setEditPage] = useState(0);
  const handleEditPage = (page) => {
    setEditPage(page);
    setDisplayEdit(true);
  };

  // returns a JSX snippet for displaying the values
  // in the form, e.g. Name: name entered
  const displayValue = (name, value, required, editNumber) => {
    return (
      <p className={Styles.formValue}>
        {name && <b>{name}: &nbsp;&nbsp;</b>}
        {value ? (
          <span>{value}</span>
        ) : required ? (
          <span
            className={Styles.required}
            onClick={() => handleEditPage(editNumber)}
          >
            Field required
          </span>
        ) : (
          blankMessage
        )}
      </p>
    );
  };

  function handleSubmit() {
    let formData = {...fields};
    formData = fieldsToStrings(formData);
    formData.userType = userTypes.findIndex(type => type.value === formData.userType);
    formData.onBehalfOf = formData.userType === 1 && formData.onBehalfOf === BehalfOfOptions[1]
      ? true
      : false;
    formData.lossCauseFull = formData.lossCause;
    formData.lossCause = lossCauses.find((item) => item.FullText === formData.lossCause)
          ?.Code;
    formData.whereCountry = countryToCode(formData.whereCountry);
    if (formData.whereCountry === Canada.code) {
      formData.whereState = stateNameToCode(formData.whereState);
    }
    formData.whereProvenanceCanada = formData.whereState;
    formData.whereStateMexico = formData.whereState;
    formData.whereZipcodeCanada = formData.whereZipcode;
    formData.propertyOwnerProvenanceCanada = formData.propertyOwnerState;
    formData.propertyOwnerStateMexico = formData.propertyOwnerState;
      formData.propertyOwnerZipcodeCanada = formData.propertyOwnerZipcode;
      formData.propertyOwnerCountry = countryToCode(formData.propertyOwnerCountry);
      if (formData.propertyOwnerCountry === Canada.code) {
        formData.propertyOwnerState = stateNameToCode(formData.propertyOwnerState);
      }
      if (formData.vehicleIs !== vehicleOwnerOptions[1].value) {
        formData.rentalCompanyName = null;
      }
      formData.rentalAddress = formData.nonPolicyVehicleAddress;
      formData.rentalCity = formData.nonPolicyVehicleCity;
      formData.rentalState = formData.nonPolicyVehicleState;
      formData.rentalZipcode = formData.nonPolicyVehicleZipCode;
      formData.rentalPhone = formData.nonPolicyVehiclePhone;
      if (formData.vehicleIs !== vehicleOwnerOptions[2].value) {
        formData.ownedFirstName = null;
        formData.ownedLastName = null;
      }
      formData.ownedAddress = formData.nonPolicyVehicleAddress;
      formData.ownedCity = formData.nonPolicyVehicleCity;
      formData.ownedState = formData.nonPolicyVehicleState;
      formData.ownedZipcode = formData.nonPolicyVehicleZipCode;
      formData.ownedPhone = formData.nonPolicyVehiclePhone;
      delete formData.nonPolicyVehicleAddress;
      delete formData.nonPolicyVehicleCity;
      delete formData.nonPolicyVehicleState;
      delete formData.nonPolicyVehicleZipCode;
      delete formData.nonPolicyVehiclePhone;
      formData.witnesses = mapPersonArray(witnesses);
      formData.pedestrians =
        mapPersonArray(pedestrians);
      formData.passengers = mapPassengerArray(passengers);
      formData.otherPassengers = mapPassengerArray(otherPassengers);
      formData.pedestrianInjured = textToBoolean(formData.pedestrianInjured);
      formData.werePassengers = textToBoolean(formData.werePassengers);
      formData.werePassengersOtherVehicle = textToBoolean(formData.werePassengersOtherVehicle);
      formData.witnessesPresent = textToBoolean(formData.witnessesPresent);
      formData.policeAgencyContacted = textToBoolean(formData.policeAgencyContacted);
      formData.otherVehicleOwner = formData.otherDriverIsOwner;
      delete formData.otherDriverIsOwner;
      if(!formData.otherVehicleDriverFirstName && !formData.otherVehicleDriverLastName) {
        formData.otherVehicleDriverLastName = unknownName;
      }
      formData.policyNumber = policyNumber || "000000000";
      delete formData.confirmEmail;
      formData.policySuccess = false;
      dispatch(
        sendAutoForm(
          formData,
          documents.files,
          "Automobile",
          typeOfClaim,
          history
        )
      );
  }

  return (
    <>
      <SubmitConfirmAlert
        isVisible={displayAlert}
        setIsVisible={setDisplayAlert}
        handleSubmit={handleSubmit}
      />
      <SummaryEditModal isVisible={displayEdit} setIsVisible={setDisplayEdit}>
        {editScreens[editPage]}
      </SummaryEditModal>

      <PageWrapper legendInfo="Claim Summary">
        <div className={Styles.review}>
          <p>
            Please review the details below and make any necessary changes
            before submitting your claim.
          </p>
          <hr className={Styles.hr}></hr>
          <br />
          {displayValue("Type of Claim", "Vehicle")}
          <hr className={Styles.hr} />

          {displayValue(
            "Date and Time Of Incident",
            formatSummaryDateTime(fields.whereDate.value, fields.whereTime.value) &&
              fields.whereDate.value.substring(0, 4) > 1949 &&
              fields.whereDate.value.substring(0, 4) <= new Date().getFullYear() ? (
              formatSummaryDateTime(fields.whereDate.value, fields.whereTime.value)
            ) : (
              <span
                className={Styles.required}
                onClick={() => handleEditPage(0)}
              >
                A valid date and time are required.
              </span>
            )
          )}
          <button
            type="button"
            className={Styles.editButton}
            onClick={() => handleEditPage(0)}
          >
            Edit
          </button>
          <hr className={Styles.hr} />

          {displayValue("Policy Number", policyNumber)}
          <button
            type="button"
            className={Styles.editButton}
            onClick={() => handleEditPage(1)}
          >
            Edit
          </button>
          <hr className={Styles.hr} />
        </div>
        <div className={Styles.flexRow}>
          <div className={Styles.summaryContainer}>
            <div className={Styles.summaryRow}>
              <SummarySection title="Claimant Information" alignment="whole">
                {displayValue("First Name", fields.contactFirstName.value)}
                {displayValue("Last Name", fields.contactLastName.value)}
                <span className={Styles.breakWord}>
                  {displayValue("Email", fields.contactEmail.value, true, 2)}
                </span>
                {displayValue("Phone", fields.contactPhone.value, true, 2)}
                <span className={Styles.breakWord}>
                  {displayValue("Confirm", fields.confirmEmail.value, true, 2)}
                </span>
                {fields.confirmEmail.value !== fields.contactEmail.value 
                  && <span></span>}
                {fields.confirmEmail.value !== fields.contactEmail.value
                 && (
                  <span
                    className={Styles.required}
                    onClick={() => handleEditPage(2)}
                  >
                    Emails do not match, click to edit.
                  </span>
                )}
                {displayValue("You are", fields.userType.value)}
                <span></span>
                {fields.userType.value === userTypes[1].value && 
                  displayValue("Filing On Behalf Of", fields.onBehalfOf.value, true, 2)}
              </SummarySection>
            </div>
            {fields.userType.value === userTypes[1].value &&
              fields.onBehalfOf.value === BehalfOfOptions[1] && (
                <>
                  <p className={Styles.hr}></p>
                  <SummaryText title="Third Party Claimant">
                    {displayValue("First Name", fields.behalfOfFirst.value, false, 2)}
                    {displayValue("Last Name", fields.behalfOfLast.value, true, 2)}
                  </SummaryText>
                </>
              )}
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(2)}
              >
                Edit
              </button>
            </div>
            <hr className={Styles.hr} />
            <div className={Styles.summaryRow}>
              <SummarySection title="Incident Location" alignment="left">
                {displayValue("Address", fields.whereAddress.value)}
                {displayValue("City", fields.whereCity.value)}
                {fields.whereCountry.value === Canada.name
                  ? displayValue(
                      "Province",
                      fields.whereState.value,
                      true,
                      3
                    )
                  : displayValue("State", fields.whereState.value, true, 3)}
                {displayValue("Zip Code", fields.whereZipcode.value)}
                {displayValue("County", fields.whereCounty.value)}
                {displayValue("Country", fields.whereCountry.value)}
                <button
                  type="button"
                  className={Styles.editButton}
                  onClick={() => handleEditPage(3)}
                >
                  Edit
                </button>
              </SummarySection>
              {fields.whoIsTheInsured.value ? (
                <SummarySection title="The Driver" alignment="right">
                  {displayValue("First Name", fields.driverFirstName.value)}
                  {displayValue("Last Name", fields.driverLastName.value, true, 4)}
                  {displayValue("Injured?", booleanToText(fields.driverIsInjured.value), false, 4)}
                  <p>This is the insured.</p>
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(4)}
                  >
                    Edit
                  </button>
                </SummarySection>
              ) : (
                <SummarySection title="The Driver" alignment="right">
                  {displayValue("First Name", fields.driverFirstName.value)}
                  {displayValue("Last Name", fields.driverLastName.value, true, 4)}
                  {displayValue("Injured?", booleanToText(fields.driverIsInjured.value), false, 4)}
                  <p>This is not the insured.</p>
                  {displayValue("Address", fields.whoAddress.value)}
                  {displayValue("City", fields.whoCity.value)}
                  {displayValue("State", fields.whoState.value, true, 4)}
                  {displayValue("County", fields.whoCounty.value)}
                  {displayValue("Zip Code", fields.whoZipcode.value, true, 4)}
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(4)}
                  >
                    Edit
                  </button>
                </SummarySection>
              )}
            </div>
            <hr className={Styles.hr}></hr>

            <div className={Styles.summaryRow}>
              <SummaryText title="Incident Details">
                {displayValue("Incident Description", fields.whatHappen.value, true, 5)}
                {displayValue("Cause of Loss", fields.lossCause?.value, true, 5)}
                <button
                  type="button"
                  className={Styles.editButton}
                  onClick={() => handleEditPage(5)}
                >
                  Edit
                </button>
              </SummaryText>
            </div>
            <hr className={Styles.hr}></hr>

            <div className={Styles.summaryRow}>
              <div className={Styles.summaryColumn}>
                <SummarySection title="The Vehicle" alignment="whole">
                  <b>
                    The vehicle{" "}
                    {fields.vehicleIs.value === vehicleOwnerOptions[0].value
                      ? "is listed on the policy."
                      : fields.vehicleIs.value === vehicleOwnerOptions[1].value
                      ? "is a rental."
                      : "is owned by another person."}
                  </b>
                  <br />
                  {displayValue("Year", fields.vehicleYear.value)}
                  {displayValue("Make", fields.vehicleMake.value)}
                  {displayValue("Model", fields.vehicleModel.value)}
                  {displayValue("VIN", fields.vehicleVin.value)}
                </SummarySection>

                <p className={Styles.hr}></p>

                <div className={Styles.summaryRow}>
                  <SummarySection title="Vehicle Location" alignment="left">
                    {displayValue("Description", fields.currentLocation.value)}
                    {displayValue("Address", fields.currentLocationVehicleAddress.value)}
                    {displayValue("City", fields.currentLocationVehicleCity.value)}
                    {displayValue("State", fields.currentLocationVehicleState.value)}
                    {displayValue("Zip Code", fields.currentLocationVehicleZip.value)}
                  </SummarySection>

                  <SummarySection title="Damage" alignment="right">
                    {displayValue(
                      "Description",
                      fields.vehicleDescribe.value,
                      true,
                      6
                    )}
                    {displayValue(
                      "Estimate",
                      `$ ${fields.vehicleEstimateDamage.value}`,
                      true,
                      6
                    )}
                    <p>
                      <b>
                        The vehicle is{" "}
                        {!fields.vehicleDriveable.value ? "not " : " "}driveable.
                      </b>
                    </p>
                  </SummarySection>
                </div>

                {fields.vehicleIs.value !== vehicleOwnerOptions[0].value && (
                  <div className={Styles.summaryRow}>
                    <SummarySection
                      title="Vehicle Owner Information"
                      alignment="right"
                    >
                      {fields.vehicleIs.value === vehicleOwnerOptions[1].value &&
                        displayValue(
                          "Company Name",
                          fields.rentalCompanyName.value,
                          true,
                          6
                        )}
                      {fields.vehicleIs.value === vehicleOwnerOptions[2].value &&
                        displayValue("First Name", fields.ownedFirstName.value)}
                      {fields.vehicleIs.value === vehicleOwnerOptions[2].value &&
                        displayValue(
                          "Last Name",
                          fields.ownedLastName.value,
                          true,
                          6
                      )}
                      {displayValue("Address", fields.nonPolicyVehicleAddress.value)}
                      {displayValue("City", fields.nonPolicyVehicleCity.value)}
                      {displayValue("State", fields.nonPolicyVehicleState.value)}
                      {displayValue("Zip Code", fields.nonPolicyVehicleZipCode.value)}
                      {displayValue("Phone", fields.nonPolicyVehiclePhone.value)}
                      <p></p>
                    </SummarySection>
                  </div>
                )}
              </div>
            </div>
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(6)}
              >
                Edit
              </button>
            </div>

            <hr className={Styles.hr}></hr>

            <div className={Styles.summaryRow}>
              {!textToBoolean(fields.witnessesPresent.value) ||
              witnesses.every((witness) => nameIsBlank(witness)) ? (
                <SummaryText title="Witnesses">
                  <p>No witnesses reported.</p>
                </SummaryText>
              ) : (
                <>
                  <SummarySection title="Witnesses" alignment="whole">
                    {witnessDisplay.map((entry) =>
                      displayValue(entry[0], entry[1])
                    )}
                  </SummarySection>
                </>
              )}
            </div>
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(7)}
              >
                Edit
              </button>
            </div>
            <hr className={Styles.hr}></hr>
            <div className={Styles.summaryRow}>
             <SummaryText
                title="Injured Pedestrians"
                alignment="whole"
              >
                {!textToBoolean(fields.pedestrianInjured.value) ||
                pedestrians.every((pedestrian) => nameIsBlank(pedestrian)) ? (
                  <p>No injured pedestrians reported.</p>
                ) : (
                  pedestrians
                    .filter((pedestrian) => !nameIsBlank(pedestrian))
                    .map((pedestrian) => {
                      return (
                        <>
                          {displayValue(
                            "Name",
                            `${concatenateName(pedestrian)}`
                          )}
                        </>
                      );
                    })
                )}
              
              </SummaryText>
            </div>
              <div className={Styles.summaryRow}>
                <button
                  type="button"
                  className={Styles.editButton}
                  onClick={() => handleEditPage(10)}
                >
                  Edit
                </button>
              </div>
            <hr className={Styles.hr}></hr>
            <div className={Styles.summaryRow}>
              <SummarySection
                title={
                  fields.otherVehicleInvolved.value
                    ? `Passengers - ${concatenateName(
                        {
                          firstName: fields.driverFirstName,
                          lastName: fields.driverLastName
                        }
                      )}'s Vehicle`
                    : "Passengers"
                }
                alignment={fields.otherVehicleInvolved.value ? "center" : "right"}
              >
                {!textToBoolean(fields.werePassengers.value) ||
                passengers.length === 0 ? (
                  <p>No passengers reported.</p>
                ) : (
                  <ol>
                  {passengers
                    .map((passenger) => {
                      return (
                        <li>
                          {displayValue(
                            "Name",
                            `${concatenateName(passenger)}`
                          )}
                          {displayValue("Injured?", booleanToText(passenger.isInjured.value))}
                          {displayValue("Address", passenger.address.value)}
                          {displayValue("City", passenger.city.value)}
                          {displayValue("State", passenger.state.value)}
                          {displayValue("Zip", passenger.zipCode.value)}
                          {displayValue("Phone Number", passenger.phoneNumber.value)}
                        </li>
                      );
                    })}
                    </ol>
                )}
                <button
                  type="button"
                  className={Styles.editButton}
                  onClick={() => handleEditPage(8)}
                >
                  Edit
                </button>
              </SummarySection>
              {fields.otherVehicleInvolved.value && (
                <SummarySection
                  title={`Passengers - ${
                    !nameIsBlank({firstName: fields.otherVehicleDriverFirstName, lastName: fields.otherVehicleDriverLastName})
                      ? `${concatenateName({firstName: fields.otherVehicleDriverFirstName, lastName: fields.otherVehicleDriverLastName})}'s`
                      : "Other"
                  } Vehicle`}
                  alignment="left"
                >
                  {!textToBoolean(fields.werePassengersOtherVehicle.value) ||
                  otherPassengers.length === 0 ? (
                    <p>No passengers reported.</p>
                  ) : (
                    <ol>
                    {otherPassengers
                      .map((passenger) => {
                        return (
                          <li>
                            {displayValue(
                              "Name",
                              `${concatenateName(passenger)}`
                            )}
                            {displayValue("Injured?", booleanToText(passenger.isInjured.value))}
                          {displayValue("Address", passenger.address.value)}
                          {displayValue("City", passenger.city.value)}
                          {displayValue("State", passenger.state.value)}
                          {displayValue("Zip", passenger.zipCode.value)}
                          {displayValue("Phone Number", passenger.phoneNumber.value)}
                          </li>
                        );
                      })}
                      </ol>
                  )}
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(9)}
                  >
                    Edit
                  </button>
                </SummarySection>
              )}
            </div>

            <hr className={Styles.hr}></hr>

            <div className={Styles.summaryRow}>
              {fields.otherVehicleInvolved.value ? (
                <SummarySection title="The Other Vehicle" alignment="left">
                  {displayValue("Year", fields.otherVehicleYear.value)}
                  {displayValue("Make", fields.otherVehicleMake.value)}
                  {displayValue("Model", fields.otherVehicleModel.value)}
                  {displayValue("Plate Number", fields.otherVehiclePlateNumber.value)}
                  {displayValue("State", fields.otherVehicleState.value)}
                  {displayValue("Damage", fields.otherVehicleDescribe.value, true, 11)}
                  <br />
                  <b>Other Driver</b>
                  {displayValue("First Name", fields.otherVehicleDriverFirstName.value)}
                  {displayValue("Last Name", fields.otherVehicleDriverLastName.value)}
                  {displayValue("Injured?", booleanToText(fields.otherVehicleDriverInjured.value))}
                  {displayValue("Address", fields.otherVehicleDriverAddress.value)}
                  {displayValue("City", fields.otherVehicleDriverCity.value)}
                  {displayValue("State", fields.otherVehicleDriverState.value)}
                  {displayValue("Zip Code", fields.otherVehicleDriverZipcode.value)}
                  {displayValue("Phone", fields.otherVehicleDriverPhone.value)}
                  {!fields.otherDriverIsOwner.value && <br />}
                  {!fields.otherDriverIsOwner.value && <b>Owner Of Other Vehicle</b>}
                  {!fields.otherDriverIsOwner.value &&
                    displayValue("First Name", fields.otherVehicleOwnerFirstName.value)}
                  {!fields.otherDriverIsOwner.value &&
                    displayValue("Last Name", fields.otherVehicleOwnerLastName.value)}
                  {!fields.otherDriverIsOwner.value &&
                    displayValue("Address", fields.otherVehicleOwnerAddress.value)}
                  {!fields.otherDriverIsOwner.value &&
                    displayValue("City", fields.otherVehicleOwnerCity.value)}
                  {!fields.otherDriverIsOwner.value &&
                    displayValue("State", fields.otherVehicleOwnerState.value)}
                  {!fields.otherDriverIsOwner.value &&
                    displayValue("Zip Code", fields.otherVehicleOwnerZipcode.value)}
                  {!fields.otherDriverIsOwner.value &&
                    displayValue("Phone", fields.otherVehicleOwnerPhone.value)}
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(11)}
                  >
                    Edit
                  </button>
                </SummarySection>
              ) : (
                <SummarySection title="The Other Vehicle" alignment="left">
                  <p>No other vehicle was involved.</p>
                  <button
                    type="button"
                    className={Styles.editButton}
                    onClick={() => handleEditPage(11)}
                  >
                    Edit
                  </button>
                </SummarySection>
              )}
            </div>

            <hr className={Styles.hr} />

            <div className={Styles.summaryRow}>
              <div className={Styles.summaryColumn}>
                {!fields.damageToProperty.value ? (
                  <SummaryText title="Property Damage">
                    <p>
                      There was no damage to a property other than vehicles.
                    </p>
                    <br />
                  </SummaryText>
                ) : (
                  <SummarySection title="Property Damage" alignment="left">
                    <p>There was damage to a property other than vehicles.</p>
                    <br />
                    <p>
                      <b>
                        {!fields.whoOwnsProperty.value
                          ? "The owner of this property is not known."
                          : "Property Owner Information:"}
                      </b>
                    </p>
                    {fields.whoOwnsProperty.value && (
                      <>
                        {displayValue("First Name", fields.propertyOwnerFirstName.value)}
                        {displayValue("Last Name", fields.propertyOwnerLastName.value)}
                        {displayValue("Address", fields.propertyOwnerAddress.value)}
                        {displayValue("City", fields.propertyOwnerCity.value)}
                        {fields.propertyOwnerCountry.value === Canada.name
                          ? displayValue(
                              "Province",
                              fields.propertyOwnerState.value
                            )
                          : displayValue("State", fields.propertyOwnerState.value)}
                        {displayValue("County", fields.propertyOwnerCounty.value)}
                        {displayValue("Zip Code", fields.propertyOwnerZipcode.value)}
                        {displayValue("Country", fields.propertyOwnerCountry.value)}
                        {displayValue("Phone", fields.propertyOwnerPhone.value)}
                        <p className={Styles.hr}></p>
                        {displayValue(
                          "Property Description",
                          fields.propertyOwnerDescribeProperty.value,
                          true,
                          12
                        )}
                        {displayValue(
                          "Damage Description",
                          fields.propertyOwnerDamageProperty.value,
                          true,
                          12
                        )}
                        <p className={Styles.hr}></p>
                        <p>
                          <b>Location Where The Damage Can Be Seen:</b>
                        </p>
                        {displayValue("Address", fields.propertyLocationAddress.value)}
                        {displayValue("City", fields.propertyLocationCity.value)}
                        {displayValue("State", fields.propertyLocationState.value)}
                        {displayValue("Zip Code", fields.propertyLocationZip.value)}
                      </>
                    )}
                  </SummarySection>
                )}
              </div>
            </div>
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(12)}
              >
                Edit
              </button>
            </div>

            <hr className={Styles.hr} />

            <div className={Styles.summaryRow}>
              {!fields.policeAgencyContacted.value ? (
                <SummaryText title="Report">
                  <p>No report was made.</p>
                </SummaryText>
              ) : (
                <SummarySection title="The Report" alignment="whole">
                  {displayValue("Agency Name", fields.reportAgencyName.value)}
                  {displayValue("Report Number", fields.reportNumber.value)}
                </SummarySection>
              )}
            </div>
            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(13)}
              >
                Edit
              </button>
            </div>
            <hr className={Styles.hr} />

            <div className={Styles.summaryRow}>
              <SummaryText title="Uploaded Files">
                {documents.size > 0 ? (
                  documents.files.map((file, index) =>
                    displayValue(`File ${index + 1} `, file.name)
                  )
                ) : (
                  <p>No documents were uploaded.</p>
                )}
              </SummaryText>
            </div>

            <div className={Styles.summaryRow}>
              <button
                type="button"
                className={Styles.editButton}
                onClick={() => handleEditPage(14)}
              >
                Edit
              </button>
            </div>
            <hr className={Styles.hr} />

            <button
              className={Styles.reportButton}
              type="button"
              onClick={(e) => handleSubmit(e)}
            >
              Report Your Claim
            </button>
            {/* */}

            <hr className={Styles.hr} />
          </div>
        </div>
        {/* console.log(`Validators: ${JSON.stringify(validators)}`) */}
      </PageWrapper>
    </>
  );
}

export default AutoClaimSummary;
